import {
  Button,
  Chip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Input,
  Select,
  SelectItem,
  Textarea,
  useDisclosure,
} from "@nextui-org/react";

import React, { useEffect, useState } from "react";
import { AILogo } from "../../constant/FormBuilder/FormBuilderConstant";

import {
  getSingleCollectionData,
  PublishData,
  UpdateSingleCollectionData,
  getDataWithFilterUrl,
} from "../../controllers/APIController";
import {
  ApprovalWorkFlowDataSchemaObj,
  FieldList,
  FrameWorkDataSchemaObj,
  FrequecyCountMap,
  FrequencyDataObj,
} from "../../utils/constant";
import PreviewForm from "./PreviewForm";
import EnhancedPreviewForm from "./EnhancedPreviewForm";
import AddModal from "./AddModal";
import FieldInfoTable from "./FieldInfoTable";
import { useNavigate, useParams } from "react-router-dom";
import AddFormulaModal from "./AddFormulaModal";
import FormulaInfoTable from "./FormulaInfoTable";
import {
  CustomFrequencyInput,
  DropDownInput,
  MultiSelectInput,
} from "./InputField/InputField";
import MetricTagInput from "./InputField/MetricTagInput";
import useGetAllModels from "../../hooks/useGetAllModels";
import {
  getAllApproverOfOrgnization,
  getAllReviewerOfOrgnization,
  getAllUserOfOrgnization,
  getFieldInfoListFromGetJSonSchema,
  getLinkInfoListFromJson,
} from "../../utils/helper";
import {
  ApproverUserSchemaObj,
  AssignedToUserSchemaObj,
  ReviewerUserSchemaObj,
  sectorSchema,
} from "../../constant/FormBuilder/FormBuilderConstant";
import useGetSectorName from "../../hooks/useGetSectorName";
import useGetDefaultOrg from "../../hooks/useGetDefaultOrg";
import FrameworFieldAccodian from "./FrameworFieldAccodian";
import ComingSoon from "../../components/ComingSoon";
import { getJSonSchemaFromFieldInfoList, generateUniqueId } from "../../utils/frombuilder.utils";
import { StandardAddButton } from "../../components/StandardButtons";

const initialFormData = {
  metricName: "",
  Category: "",
  className: "",
  description: "",
  frameWork: [],
  ApprovalWorkFlow: "Default",
  SectorText: "",
};



const getLinkJsonReponse = (list) => {
  const reponse = [];
  list.forEach((item) => {
    reponse.push({
      id: item?.id,
      name: item.Title,
      link: item.link,
    });
  });
  return {
    Links: reponse,
  };
};

const UIMetricBuilderValidation = (
  formData,
  fieldInfoList,
  requiredArr,
  allMetricName
) => {
  const err = {};
  let isValid = true;

  console.log("AIFormBuilder Validation - formData:", formData);
  console.log("AIFormBuilder Validation - allMetricName:", allMetricName);
  console.log("AIFormBuilder Validation - metricName to check:", formData["metricName"]?.trim()?.toLowerCase());

  if (fieldInfoList.length === 0) {
    err["BuildData"] = "Build Data should have atleast one field";
    isValid = false;
  }
  
  // Allow copying by checking if the name ends with "(Copy)"
  const metricName = formData["metricName"]?.trim()?.toLowerCase();
  const isCopying = metricName?.endsWith("(copy)");
  
  if (allMetricName?.includes(metricName) && !isCopying) {
    err["metricName"] = "Metric Name already have been used";
    isValid = false;
    console.log("AIFormBuilder Validation failed - metric name already exists");
  }

  Object.keys(formData).forEach((key) => {
    if (requiredArr.includes(key) && formData[key] === "") {
      err[key] = `${key} is required`;
      isValid = false;
    }
  });
  
  console.log("AIFormBuilder Validation result:", { isValid, error: err, isCopying });
  return { isValid: isValid, error: err };
};

const AIFormBuilder = ({ metricInfo, isCopying = false }) => {
  const navigator = useNavigate();
  const { _orgId } = useParams();

  const { allModels, setAllModels } = useGetAllModels();
  const [loader, setLoader] = useState(true);
  const [initialDataLoading, setInitialDataLoading] = useState(true);
  const { allSectorName } = useGetSectorName();
  const { OrgDetail: DefaultOrgDetail } = useGetDefaultOrg();
  
  // Initialize formData before useEffect that references it
  const [formData, setFormData] = useState(initialFormData);
  
  // Set default sector when sectors are loaded
  useEffect(() => {
    if (allSectorName?.length && !formData.SectorText) {
      const generalSector = allSectorName.find(sector => 
        sector.name?.toLowerCase() === "general"
      );
      const defaultSector = generalSector || allSectorName[0];
      if (defaultSector) {
        setFormData(prev => ({
          ...prev,
          SectorText: defaultSector.name
        }));
      }
    }
  }, [allSectorName, formData.SectorText]);

  // Get organization info for API calls
  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;
  const orgFilterUrl = "filters[Organization][id][$eqi]=" + OrgInfo;

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
  }, [OrgInfo]);

  const [allMetricName, setAllMetricName] = useState([]);
  const [frameWorkList, setFrameWorkList] = useState([]);
  const [frameWorkDetails, setFrameWorkDetails] = useState({});
  const [MetricNameList, setMetricNameList] = useState({
    TCFD: "",
    BRSR: "",
    SASB: "",
    GRI: "",
  });
  const [overviewList, setOverviewList] = useState({
    TCFD: "",
    BRSR: "",
    SASB: "",
    GRI: "",
  });
  const [guidanceList, setGuidanceList] = useState({
    TCFD: "",
    BRSR: "",
    SASB: "",
    GRI: "",
  });

  const [frequency, setFrequency] = useState(FrequencyDataObj?.values[0]?.name);
  const [customFrequency, setCustomFrequency] = useState(0.01);

  const showCustomFrequencyInput = frequency === "Custom";

  const [validationErrors, setValidationErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});

  const [fieldType, setFieldType] = useState(""); // field type that we want to create
  const [fieldInfoList, setFieldInfoList] = useState([]); // JsonSchema Input field info
  const [LinkInfoList, setLinkInfoList] = useState([]); // Link field info in Metric
  const [selectedFormulaList, setSelectedFormulaList] = useState([]);
  const [FormulaInfoList, setFormulaInfoList] = useState([]); //  field info in Metric

  const [selectedAssignedTo, setSelectedAssignedTo] = useState([]);
  const [selectedApproverTo, setSelectedApproverTo] = useState([]);
  const [selectedReviewerTo, setSelectedReviewerTo] = useState([]);
  const [AllUserList, setAllUserList] = useState([]);
  const [AllApproverList, setAllApproverList] = useState([]);
  const [AllReviewerList, setAllReviewerList] = useState([]);

  const [tags, setTags] = useState([]);
  const [allTags, setAllTags] = useState([]);

  const [tagsValidation, setTagsValidation] = useState("");

  // Dynamic category state
  const [dynamicCategories, setDynamicCategories] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);

  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const {
    isOpen: isOpenLink,
    onOpen: onOpenLink,
    onOpenChange: onOpenChangeLink,
  } = useDisclosure();

  const {
    isOpen: isOpenFormula,
    onOpen: onOpenFormula,
    onOpenChange: onOpenChangeFormula,
  } = useDisclosure();

  const requiredArr = [
    "metricName",
    "Category",
    "jsonSchema",
    "ApprovalWorkFlow",
  ];

  const FrameWorkDataSchema = FrameWorkDataSchemaObj;
  FrameWorkDataSchema.values = frameWorkList;

  // Fetch categories from metrics API
  const fetchCategories = async () => {
    if (!OrgInfo) return;
    
    setIsLoadingCategories(true);
    try {
      const data = await getDataWithFilterUrl("metrics", orgFilterUrl);
      const metricsList = data?.data || [];
      
      // Extract unique categories from metrics data
      const uniqueCategories = [...new Set(
        metricsList.map(item => item?.attributes?.Category).filter(Boolean)
      )].sort();
      
      // Convert to the format expected by the dropdown
      const categoriesList = uniqueCategories.map((category, index) => ({
        id: (index + 1).toString(),
        name: category,
      }));
      
      setDynamicCategories(categoriesList);
    } catch (error) {
      console.error("Error fetching categories:", error);
      // Fallback to empty array if API fails
      setDynamicCategories([]);
    } finally {
      setIsLoadingCategories(false);
    }
  };

  const fieldListValues = Object.keys(FieldList).map((key) => [key, FieldList[key]]);
  const changeHandler = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const showPreviewHandler = () => {
    setShowPreview(false);
    const validationResponse = UIMetricBuilderValidation(
      formData,
      fieldInfoList,
      requiredArr,
      allMetricName
    );

    setValidationErrors(validationResponse.error);
    if (!validationResponse.isValid) {
      return;
    }

    const JsonSchemaData = getJSonSchemaFromFieldInfoList(
      fieldInfoList,
      FormulaInfoList
    );
    const frameWorkResponse = { id: formData?.frameWork || [] };

    const publishData = {
      Name: formData.metricName,
      Category: formData.Category,
      ClassName: formData.className,
      Description: formData.description,
      WorkFlow: formData.ApprovalWorkFlow,
      Framework: frameWorkResponse,
      JsonSchema: JsonSchemaData,
      Links: getLinkJsonReponse(LinkInfoList),
      FrequencyValue:
        frequency === "Custom" ? +customFrequency : FrequecyCountMap[frequency],
      Organization: OrgInfo,
    };

    setPreviewData(publishData);
    setShowPreview(true);
  };

  const submitHandler = async () => {
    const validationResponse = UIMetricBuilderValidation(
      formData,
      fieldInfoList,
      requiredArr,
      allMetricName
    );

    if (!validationResponse.isValid) {
      setValidationErrors(validationResponse.error);
      return;
    }
    const JsonSchemaData = getJSonSchemaFromFieldInfoList(
      fieldInfoList,
      FormulaInfoList
    );
    const frameWorkResponse = { id: formData?.frameWork || [] };
    const AssignedToData = selectedAssignedTo?.map((id) => +id);
    const ApproverToData = selectedApproverTo?.map((id) => +id);
    const ReviewerToData = selectedReviewerTo?.map((id) => +id);

    const moreInfo = {
      Guidance: guidanceList,
      Overview: overviewList,
      NameList: { ...MetricNameList, Generic: formData?.metricName },
    };

    const publishData = {
      Name: formData.metricName,
      Category: formData.Category,
      ClassName: formData.className,
      Description: formData.description,
      Sector: formData.SectorText,
      WorkFlow: formData.ApprovalWorkFlow,
      Framework: frameWorkResponse,
      JsonSchema: JsonSchemaData,
      Links: getLinkJsonReponse(LinkInfoList),
      FrequencyValue:
        frequency === "Custom" ? +customFrequency : FrequecyCountMap[frequency],
      TagList: tags,
      Organization: OrgInfo,
      AssignedTo: AssignedToData,
      ApproverTo: ApproverToData,
      ReviewerTo: ReviewerToData,
      ...moreInfo,
    };


    let result = await PublishData({ data: publishData }, "metrics");

    const newTags = tags?.filter((name) => !allTags?.includes(name));
    const updatedTags = [...allTags, ...newTags];
    await UpdateSingleCollectionData("tag", { List: updatedTags });

    navigator(`/${_orgId}/metrics-builder`);
  };

  const addFieldHandler = (listItem) => {
    // Ensure new fields get proper displayOrder
    const newField = {
      ...listItem,
      displayOrder: fieldInfoList.length
    };
    setFieldInfoList([...fieldInfoList, newField]);
  };

  const addLinkHandler = (listItem) => {
    setLinkInfoList([...LinkInfoList, listItem]);
  };
  const addFormulaHandler = (listItem) => {
    setFormulaInfoList([...FormulaInfoList, listItem]);
  };

  useEffect(() => {
    // Combine all API calls to reduce loading time
    const loadInitialData = async () => {
      try {
        // Execute all API calls in parallel for better performance
        const [
          frameworksData,
          metricsData,
          tagsData,
          usersData,
          reviewersData,
          approversData
        ] = await Promise.all([
          getDataWithFilterUrl("frameworks"),
          getDataWithFilterUrl("metrics", orgFilterUrl),
          getSingleCollectionData("tag"),
          getAllUserOfOrgnization(),
          getAllReviewerOfOrgnization(),
          getAllApproverOfOrgnization()
        ]);

        // Process frameworks
        let frameWorkData = frameworksData.data;
        const f = {};
        frameWorkData = frameWorkData?.map((item) => {
          f[item.id] = item.attributes.Name;
          return { id: item.id, name: item?.attributes?.Name };
        });
        setFrameWorkDetails(f);
        setFrameWorkList(frameWorkData);

        // Set default framework to "General" if it exists, otherwise use first available
        const generalFramework = frameWorkData?.find(item => 
          item.name?.toLowerCase() === "general"
        );
        const defaultFramework = generalFramework || frameWorkData?.[0];
        if (defaultFramework && !formData.frameWork?.length) {
          setFormData(prev => ({
            ...prev,
            frameWork: [defaultFramework.id]
          }));
        }

        // Process metrics
        const metricsList = metricsData?.data?.map((a) => {
          return a?.attributes?.Name.trim().toLowerCase();
        });
        setAllMetricName(metricsList);

        // Process tags
        setAllTags(tagsData?.data?.attributes?.List || []);

        // Process users
        const processedUsers = usersData?.map((user) => ({
          id: user.id,
          name: user.username
        }));
        const processedReviewers = reviewersData?.map((user) => ({
          id: user.id,
          name: user.username
        }));
        const processedApprovers = approversData?.map((user) => ({
          id: user.id,
          name: user.username
        }));

        setAllUserList(processedUsers);
        setAllApproverList(processedApprovers);
        setAllReviewerList(processedReviewers);

        setInitialDataLoading(false);
      } catch (err) {
        console.error("Error loading initial data:", err);
        setInitialDataLoading(false);
      }
    };

    loadInitialData();
  }, [orgFilterUrl]);

  useEffect(() => {
    let response = metricInfo;

    if (!response) {
      return;
    }
    setFormData({
      metricName: response?.attributes?.Name || "",
      Category: response?.attributes?.Category || "",
      className: response?.attributes?.ClassName || "",
      description: response?.attributes?.Description || "",
      frameWork: response?.attributes?.Framework?.id || [],
      ApprovalWorkFlow: response?.attributes?.WorkFlow,
      SectorText: response?.attributes?.Sector || "",
    });
    const AssignedToData = response?.attributes?.AssignedTo?.data?.map((user) =>
      user?.id?.toString()
    );
    const ApproverToData = response?.attributes?.ApproverTo?.data?.map((user) =>
      user?.id?.toString()
    );
    const ReviewerToData = response?.attributes?.ReviewerTo?.data?.map((user) =>
      user?.id?.toString()
    );
    setSelectedAssignedTo(AssignedToData);
    setSelectedApproverTo(ApproverToData);
    setSelectedReviewerTo(ReviewerToData);

    const frequencyNumber = +response?.attributes?.FrequencyValue;
    const frequencyval =
      frequencyNumber === -1
        ? "Custom"
        : frequencyNumber === 30
        ? "Every month"
        : frequencyNumber === 7
        ? "Every week"
        : frequencyNumber === 1
        ? "Everyday"
        : "Only Once";
   

    setFrequency(frequencyval);

    setFieldInfoList(
      getFieldInfoListFromGetJSonSchema(
        response?.attributes?.JsonSchema
      )
    );
    setLinkInfoList(
      getLinkInfoListFromJson(response?.attributes?.Links?.Links)
    );

    setFormulaInfoList(response?.attributes?.JsonSchema?.formula || []);
    setTags(response?.attributes?.TagList || []);
    let formulaList = response?.attributes?.JsonSchema?.formula || [];
    formulaList = formulaList.map((data) => data?.id?.toString());
    setSelectedFormulaList(formulaList);
    setOverviewList(response?.attributes?.Overview || {});
    setGuidanceList(response?.attributes?.Guidance || {});
    setMetricNameList(response?.attributes?.NameList || {});
    setLoader(false);
  }, [metricInfo]);


  if (initialDataLoading) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading AI form builder...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-start justify-between my-2">
      <div className="flex flex-col items-center w-[50%]">
        {/* Metric Name Input  */}
        <Input
          type="text"
          className="my-8"
          variant="faded"
          isRequired
          label="Metric Name"
          labelPlacement="outside"
          placeholder=" "
          name="metricName"
          onChange={changeHandler}
          value={formData["metricName"]}
          isInvalid={validationErrors["metricName"]}
          errorMessage={
            validationErrors["metricName"] && validationErrors["metricName"]
          }
        />
        {isCopying && formData["metricName"] && (
          <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <p className="text-amber-800 text-sm">
              💡 <strong>Copying:</strong> You can modify the metric name above. The "(Copy)" suffix has been added automatically.
            </p>
          </div>
        )}

        {/* Category DropDown */}

        <DropDownInput
          buttonCSS={"mb-8"}
          data={{
            id: "category",
            name: "Drop Down",
            type: "dropdown",
            title: "Category",
            values: dynamicCategories,
            required: true,
            ismultiselect: false,
          }}
          value={formData?.Category === "" ? "" : formData.Category}
          validationErrors={validationErrors}
          onChangeHandler={(title, value, type) =>
            setFormData({
              ...formData,
              Category: value,
            })
          }
        />

        {/* ClassName Input */}
        <Input
          type="text"
          className="my-4"
          variant="faded"
          label="Class Name"
          placeholder=" "
          labelPlacement="outside"
          name="className"
          onChange={changeHandler}
          value={formData["className"]}
        />

        {/* Description Input  */}
        <Textarea
          label="Description"
          labelPlacement="outside"
          variant="faded"
          className="my-4"
          name="description"
          onChange={changeHandler}
          value={formData["description"]}
        />

        <Textarea
          className="my-4"
          variant="faded"
          label={`General Overview`}
          labelPlacement="outside"
          placeholder=" "
          value={overviewList["Generic"]}
          onChange={(event) =>
            setOverviewList({
              ...overviewList,
              Generic: event.target.value,
            })
          }
        />

        <Textarea
          className="my-4"
          variant="faded"
          label={`General Guidance`}
          labelPlacement="outside"
          placeholder=" "
          value={guidanceList["Generic"]}
          onChange={(event) =>
            setGuidanceList({
              ...guidanceList,
              Generic: event.target.value,
            })
          }
        />

        {DefaultOrgDetail?.id === OrgInfo && (
          <DropDownInput
            data={{
              ...sectorSchema,
              values: allSectorName,
            }}
            value={formData?.SectorText}
            validationErrors={validationErrors}
            onChangeHandler={(title, value, type) =>
              setFormData({ ...formData, SectorText: value })
            }
            buttonCSS="mb-4"
          />
        )}

        {/* FrameWork Input */}

        {formData?.Category?.toLowerCase() !== "reference data" && (
          <Select
            label="Select Framework"
            placeholder="Select any Framework"
            variant="faded"
            selectionMode="multiple"
            labelPlacement="outside"
            className="my-6"
            selectedKeys={new Set((Array.isArray(formData["frameWork"]) ? formData["frameWork"] : []).filter(id => 
              frameWorkList?.some(item => item.id.toString() === id.toString())
            ) || [])}
            onSelectionChange={(event) => {
             

              setFormData({
                ...formData,
                frameWork: Array.from(event),
              });
            }}
          >
            {frameWorkList?.map((item) => (
              <SelectItem key={item.id} value={item.name} className="py-2">
                {item.name}
              </SelectItem>
            ))}
          </Select>
        )}

        {formData?.Category?.toLowerCase() !== "reference data" &&
          formData?.frameWork &&
          formData?.frameWork?.map((id, index) => {
            return (
              <FrameworFieldAccodian
                key={`framework-${id}-${index}`}
                title={frameWorkDetails[+id]}
                setMetricNameList={setMetricNameList}
                MetricNameList={MetricNameList}
                setGuidanceList={setGuidanceList}
                guidanceList={guidanceList}
                setOverviewList={setOverviewList}
                overviewList={overviewList}
              />
            );
          })}

        {/* AssignedTo User DropDown */}
        <MultiSelectInput
          data={AssignedToUserSchemaObj}
          value={selectedAssignedTo}
          valuesList={AllUserList}
          onChangeHandler={(title, value, type) => setSelectedAssignedTo(value)}
        />

        {/* Approval Workfflow DropDown */}
        <DropDownInput
          buttonCSS={"mb-8"}
          data={ApprovalWorkFlowDataSchemaObj}
          value={formData?.ApprovalWorkFlow || ""}
          validationErrors={validationErrors}
          onChangeHandler={(title, value, type) =>
            setFormData({
              ...formData,
              ApprovalWorkFlow: value,
            })
          }
        />

        {/* Approver User DropDown */}
        {(formData?.ApprovalWorkFlow === "1-Step Approval" ||
          formData?.ApprovalWorkFlow === "2-Step Approval") && (
          <MultiSelectInput
            data={ApproverUserSchemaObj}
            value={selectedApproverTo}
            valuesList={AllApproverList}
            onChangeHandler={(title, value, type) =>
              setSelectedApproverTo(value)
            }
          />
        )}
        {/* Reviewer User DropDown */}
        {formData?.ApprovalWorkFlow === "2-Step Approval" && (
          <MultiSelectInput
            data={ReviewerUserSchemaObj}
            value={selectedReviewerTo}
            valuesList={AllReviewerList}
            onChangeHandler={(title, value, type) =>
              setSelectedReviewerTo(value)
            }
          />
        )}

        {/* Recommended Frequency DropDown */}

        <DropDownInput
          buttonCSS={"mb-8"}
          data={FrequencyDataObj}
          value={frequency}
          validationErrors={1}
          onChangeHandler={(title, value, type) => setFrequency(value)}
        />

        {showCustomFrequencyInput && (
          <CustomFrequencyInput
            value={customFrequency}
            onChangeHandler={(value) => setCustomFrequency(value)}
          />
        )}

        {/* Metrics Tags Input */}
        <MetricTagInput
          tags={tags}
          setTags={setTags}
          IntialvalidationError={tagsValidation}
          allTags={allTags}
        />

        {/* JsonSchema Input */}

        <div className="w-full mb-8">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">
              Build your Metric Schema with AI
            </p>
            <span>{AILogo}</span>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          {/* <p className="my-4 text-sm">
            Write in simple NLP for the AI to create your metric forms
          </p> */}
          <ComingSoon height={"150px"} />
          {/* <Textarea
            placeholder="Describe what type of metric you would like to create"
            variant="faded"
            className="my-4 h-full"
            name="description"
            onChange={changeHandler}
            value={formData["description"]}
          /> */}

          <div className="flex justify-end my-4 mr-4">
            <Dropdown>
              <DropdownTrigger>
                <StandardAddButton size="sm">
                  Add a new field
                </StandardAddButton>
              </DropdownTrigger>
              <DropdownMenu
                aria-label="Static Actions"
                selectionMode="single"
                onSelectionChange={(event) => {
                  const selectedKey = Array.from(event)[0];
                  // Ensure we have a valid field type
                  if (selectedKey && FieldList[selectedKey]) {
                    setFieldType(selectedKey);
                    onOpen();
                  } else {
                    console.error("Invalid field type selected:", selectedKey);
                  }
                }}
              >
                {fieldListValues.map(
                  (row) =>
                    row[1].name !== "linkUrl" && (
                      <DropdownItem key={row[0]} name={row[0]}>
                        {row[1].title}
                      </DropdownItem>
                    )
                )}
              </DropdownMenu>
            </Dropdown>
          </div>

          {isOpen && (
            <AddModal
              onSubmitHandler={addFieldHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpen}
              onOpen={onOpen}
              onOpenChange={onOpenChange}
              fieldType={fieldType}
              id={generateUniqueId('field')}
              frameWorkDetails={frameWorkDetails}
              frameWorkList={frameWorkList}
              category={formData?.Category}
              existingFields={fieldInfoList}
            />
          )}

          <FieldInfoTable
            fieldInfoList={fieldInfoList}
            setFieldInfoList={setFieldInfoList}
            frameWorkDetails={frameWorkDetails}
            frameWorkList={frameWorkList}
          /> */}
        </div>

        {/* Links Input */}
        {/*
        <div className="w-full min-h-96">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">Attach your reference links</p>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          <p className="my-4 text-sm">
            Attach reference links for users to fill your metrics easier
          </p>

          <div className="flex justify-end my-4 mr-4">
            <StandardAddButton 
              size="sm" 
              onClick={() => onOpenLink()}
              className="px-6 font-medium"
            >
              Add a new link
            </StandardAddButton>
          </div>

          {isOpenLink && (
            <AddModal
              onSubmitHandler={addLinkHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpenLink}
              onOpen={onOpenLink}
              onOpenChange={onOpenChangeLink}
              fieldType="link"
              id={generateUniqueId('link')}
            />
          )}

          <FieldInfoTable
            fieldInfoList={LinkInfoList}
            setFieldInfoList={setLinkInfoList}
            headersList={["Name", "Link", ""]}
          />
        </div>
        */}

        {/* Formula Input */}

        <div className="w-full min-h-96">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">Design your Formula</p>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          <p className="my-4 text-sm">
            Design your formula to handle mathematical calculations like
            emissions, diversity and many more.
          </p>

          <div className="flex justify-end my-4 mr-4">
            <Button 
              color="primary" 
              size="sm" 
              onClick={() => onOpenFormula()}
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium"
            >
              Add a new formula
            </Button>
          </div>

          {isOpenFormula && (
            <AddFormulaModal
              onSubmitHandler={addFormulaHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpenFormula}
              onOpen={onOpenFormula}
              onOpenChange={onOpenChangeFormula}
              fieldType="formula"
              id={generateUniqueId('formula')}
            />
          )}

          <FormulaInfoTable
            fieldInfoList={FormulaInfoList}
            setFieldInfoList={setFormulaInfoList}
          />
        </div>
        {/* Preview,Submit button */}
        <div className="flex gap-4 justify-end w-full pt-6">
          <Button
            color="default"
            variant="bordered"
            size="sm"
            onClick={showPreviewHandler}
            className="px-6"
          >
            Preview
          </Button>
          <Button 
            color="primary" 
            size="sm" 
            className="px-6 bg-emerald-600 hover:bg-emerald-700"
            onClick={submitHandler}
          >
            Submit
          </Button>
        </div>
      </div>

      {/* Preview Card Open */}
      {showPreview && (
        <div className="flex flex-col items-center w-[48%]">
          <EnhancedPreviewForm data={previewData} fieldInfoList={fieldInfoList} />
        </div>
      )}
    </div>
  );
};

export default AIFormBuilder;
